import axios from 'axios';

export const BASE_URL = 'https://youtube-v31.p.rapidapi.com';

const options = {
  
    url:BASE_URL,
  params: {
    maxResults: 100,
  },
  headers: {
    'X-RapidAPI-Key': 'f95540051dmsh5bc4447a53bc30dp1b09afjsn82cbb3fc60d3',
    'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com'
  }
};

export const fetchFromAPI = async (url) => {
    const { data } = await axios.get(`${BASE_URL}/${url}`, options);
  
    return data;
  };